import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import SectionHeader from './SectionHeader'
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import { Link } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import { HOST } from '../components/config';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import caseStatusToPill from './CaseStatusPill';

function CasesList() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('updated_at')
  const [sortOrder, setSortOrder] = useState('asc')

  useEffect(() => {
    const token = localStorage.getItem('token')
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const org_id = localStorage.getItem('org_id') || ''
        const url = (HOST + '/api/cases/?org_id=' + org_id) 
        const response = await fetch(url, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token 
            },  
        });
        const json = await response.json()
        if (response.status >= 300) {
          localStorage.removeItem('token')
          setData([]);
        }
        else {
          setData(json);
        }
      } catch (err) {
        if (token) {
          localStorage.removeItem('token')
          localStorage.removeItem('org_id')
        }
        setData([]);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs only once on mount

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data)
    return <></>

  const sortData = (_data) => {
    return _data.sort((a, b) => {
      if (sortBy == 'created_at')
        return sortOrder == 'desc' ? new Date(a.created_at) - new Date(b.created_at) : new Date(b.created_at) - new Date(a.created_at)
      else if (sortBy == 'updated_at')
        return sortOrder == 'desc' ? new Date(a.updated_at) - new Date(b.updated_at) : new Date(b.updated_at) - new Date(a.updated_at)
      else if (sortBy == 'status') {
        if (a.status == b.status)
          return 0
        return sortOrder == 'desc' ? (a.status > b.status ? -1 : 1): a.status < b.status ? -1 : 1
      }
    })
  }

  const sortedData = sortData(data)
 
  const updateSort = (clicked) => {
    if (clicked == sortBy)
      setSortOrder(sortOrder == 'asc' ? 'desc' : 'asc')
    else {
      setSortOrder('desc')
      setSortBy(clicked)
    }
  }

  return (
    <Container disableGutters={false} > 
      <SectionHeader title='Cases' mt={4} actions={(
        <Button 
          component={Link} 
          to={"/add_case"} 
          variant="contained">
          <AddIcon />&nbsp; Add Case
        </Button>)} />
      <Divider />
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow >
            <TableCell sx={{fontWeight: 'bold'}} >Case</TableCell>
            <TableCell sx={{fontWeight: 'bold', width: "140px"}} onClick={() => updateSort('updated_at')} align="center" component="th">Status Updated At{sortBy == 'updated_at' ? (sortOrder == 'desc' ? ' ↑' : ' ↓') : ''}</TableCell>
            <TableCell sx={{fontWeight: 'bold', width: "200px"}} onClick={() => updateSort('status')} align="center" component="th">Status{sortBy == 'status' ? (sortOrder == 'desc' ? ' ↑' : ' ↓') : ''}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((item) => {
            const date_s = new Date(item.created_at).toLocaleDateString()
            const date_updated_s = new Date(item.updated_at).toLocaleDateString()
            return (
        
            <TableRow
              key={item.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 }, textDecoration: "none"}}
              component={Link} 
              to={"/cases/" + item.id}
              hover
            >
              <TableCell align="left"  >
                
                <Typography sx={{fontSize: "16px"}}>
                  {item.name}
                </Typography>
              </TableCell>
              <TableCell align="center">
                {date_updated_s} 
              </TableCell>
              <TableCell align="center">
                {caseStatusToPill(item.status)}
              </TableCell>
            </TableRow>

        )})}
          </TableBody>
      </Table>
    </Container>
  );
}

export default CasesList;
